"use strict";

/* ------------------------------------------------------------------ *
 * Mapper 28: UNROM (no CHR RAM, large PRG ROM)
 * ------------------------------------------------------------------ */
// PRG: 16 KB fixed at $8000, 16 KB switchable at $C000.
// No CHR ROM / CHR-RAM only (header byte 5 = 0).
// Mirroring hardwired from header.

function register(Mappers) {
  Mappers[28] = function (nes) {
    this.nes = nes;
  };

  Mappers[28].prototype = new Mappers[0]();

  Mappers[28].prototype.irqClockRate = "none";

  Mappers[28].prototype.reset = function () {
    Mappers[0].prototype.reset.apply(this);
    this.prgBank = 0;
  };

  Mappers[28].prototype.write = function (address, value) {
    if (address < 0x8000) {
      Mappers[0].prototype.write.apply(this, arguments);
      return;
    }
    // Switchable bank at $C000 (lower 4 bits)
    this.prgBank = value & 0x0f;
    this.loadRomBank(this.prgBank, 0xc000);
  };

  Mappers[28].prototype.loadROM = function () {
    if (!this.nes.rom.valid) {
      throw new Error("Mapper 28: Invalid ROM! Unable to load.");
    }
    this.reset();
    // Large PRG ROM: CHR-RAM only (loadCHRROM handles empty vromCount)
    this.loadCHRROM();
    this.loadBatteryRam();
    this.loadTrainer();
    // First 16 KB fixed at $8000, switchable at $C000 starts at bank 0
    this.loadRomBank(0, 0x8000);
    this.loadRomBank(this.prgBank, 0xc000);
    this.resetIrqHandler();
  };

  Mappers[28].prototype.toJSON = function () {
    var s = Mappers[0].prototype.toJSON.apply(this);
    s.prgBank = this.prgBank;
    return s;
  };

  Mappers[28].prototype.fromJSON = function (s) {
    Mappers[0].prototype.fromJSON.apply(this, arguments);
    this.prgBank = s.prgBank;
    this.loadRomBank(0, 0x8000);
    this.loadRomBank(this.prgBank, 0xc000);
  };
}

module.exports = { register: register };
